export default ({ store, redirect }) => {
  if (store.state.member.auth.token) {
    return store.state.member.auth.user_roles === 'user' ? redirect('/dashboard/profile') : redirect(process.env.HOST_NAME_PROD)
  }
}
